import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=af35a9f6&scoped=true&"
import script from "./Metric.vue?vue&type=script&lang=js&"
export * from "./Metric.vue?vue&type=script&lang=js&"
import style0 from "./Metric.vue?vue&type=style&index=0&id=af35a9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af35a9f6",
  null
  
)

/* custom blocks */
import block0 from "./Metric.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports